import { EMPTY_ARRAY, FilterMetadataApiWithCountReturn, SEPARATOR } from "../misc";
import { CategoryChart } from "../processors";
import { CategoryChartParam, CategoryChartParamFetchFn } from "./types";
import * as paramFetchFns from "../categoryChartParamFetchFns";

export const fetchCategoryChartParam = async (
    // providers?: WaterProvider[],
    metadata: FilterMetadataApiWithCountReturn,
    locationAdminIds?: string[],
    categoryChart?: CategoryChart
): Promise<CategoryChartParam> => {
    const paramFetchParams = (categoryChart?.paramFetchFn ?? EMPTY_ARRAY) as string[];
    let fetchFnArg = paramFetchParams[0];
    const fetchFnParams = (fetchFnArg ?? "")?.split("???") ?? (EMPTY_ARRAY as string[]);
    const fetchFn = fetchFnParams?.[0];
    const fetchArgs = fetchFnParams?.filter((___, index) => index > 0);

    const kpisString = paramFetchParams?.filter((__, index) => index !== 0) ?? [];
    const kpis =
        kpisString?.map(kpi => {
            return (kpi ?? "")
                .split(SEPARATOR)
                .map(d => (d != null && d.toString().trim() !== "" ? d.toString().trim() : null))
                .filter(d => d != null);
        }) ?? [];

    const defaultRet = {
        fetchParams: [],
        locationAdminIds: (locationAdminIds ?? EMPTY_ARRAY).filter(d => d != null),
        categoryChart: categoryChart,
        latestYear: undefined,
        metadata,
        kpis
    };

    if (
        !locationAdminIds ||
        // !metadata ||
        !locationAdminIds.filter(d => d != null).length ||
        !categoryChart ||
        !paramFetchFns[fetchFn]
    )
        return defaultRet;

    return (paramFetchFns[fetchFn] as CategoryChartParamFetchFn)({
        fetchParams: fetchArgs,
        metadata,
        locationAdminIds,
        categoryChart,
        kpis
    });
};
